<template>
	<router-view ref="child" />
</template>
<script>
export default {
	name: 'App',
}
</script>
<style>
@import '//at.alicdn.com/t/c/font_5217965_ek6it9gjz76.css';
:root {
	--blue: #2563eb;
	--blue_dark: #1d4ed8;
	--amber: #f59e0b;
	--indigo: #4f46e5;
	--emerald: #10b981;
	--text_1: #0f172a;
	--text_2: #334155;
	--text_3: #64748b;
	--text_4: #94a3b8;
	--line: #e2e8f0;
	--line_soft: #f1f5f9;
	--bg: #f1f5f9;
}
</style>



// WEBPACK FOOTER //
// src/App.vue